exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".similarAdsSection__container___3VtrY .similarAdsSection__title___2QImN {\n  margin-bottom: 24px;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 23px;\n  letter-spacing: -0.015em;\n  text-align: left; }\n  @media screen and (max-width: 576px) {\n    .similarAdsSection__container___3VtrY .similarAdsSection__title___2QImN {\n      padding-bottom: 12px;\n      font-size: 15px;\n      margin-bottom: 0; } }\n\n.similarAdsSection__container___3VtrY {\n  margin-top: 12px;\n  background-color: #ffffff; }\n  .similarAdsSection__container___3VtrY .similarAdsSection__title___2QImN {\n    margin-left: 20px;\n    padding-top: 12px; }\n", ""]);

// exports
exports.locals = {
	"container": "similarAdsSection__container___3VtrY",
	"title": "similarAdsSection__title___2QImN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/SimilarAdsSection/similarAdsSection.scss
// module id = 4543
// module chunks = 6